/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
import Vue from 'vue'
let confrenceUserCountURL = root.confrenceUserCountUrl.link;
let confrenceUserCountCreateURL = root.confrenceUserCountCreateUrl.link;
let confrenceUserCountLeftURL = root.confrenceUserCountLeftUrl.link;
let zoomMeetingCreateApiUrl = root.zoomMeetingCreateApiUrl.link;
let vistaSignupUsersListApiUrl = root.vistaSignupUsersListApiUrl.link;
export default {
  state: {
    vistaConferenceState:{},
    vistaConferenceUserState:{}
  },
  mutations: {
    vistaConferenceMutation(state, value) {
      Vue.set(state, 'vistaConferenceState', value);
    },
    vistaConferenceUserMutation(state, value) {
        Vue.set(state, 'vistaConferenceUserState', value);
      }
  },
  actions: {
    // confrence User Count
    confrenceUserCountFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(confrenceUserCountURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // confrence User Count
    confrenceUserCountCreatedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(confrenceUserCountCreateURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // confrence User Count
    confrenceUserCountLeftedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(confrenceUserCountLeftURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // vista confrence User Count
  vistaConferenceListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(zoomMeetingCreateApiUrl, payload).then(res => {
                context.commit('vistaConferenceMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // vista confrence User Count
  vistaConferenceUserListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(vistaSignupUsersListApiUrl, payload).then(res => {
                context.commit('vistaConferenceUserMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    vistaConferenceGetters: state => state.vistaConferenceState,
    vistaConferenceUserGetters: state => state.vistaConferenceUserState,
  }
}